if (!window.Eurus.loadedScript.has('collection-list-truncate-text.js')) {
  window.Eurus.loadedScript.add('collection-list-truncate-text.js');

  document.addEventListener('alpine:init', () => {
    Alpine.data('xCollectionListTruncateText', () => ({
      truncated: false,
      truncatable: false,
      label: '',
      expanded: false,
      load(truncateEl) {
        const truncateRect = truncateEl.getBoundingClientRect();
        truncateEl.style.setProperty('--truncate-height', `${truncateRect.height}px`);
      },
      setTruncate(element) {
        const computedLineHeight = parseFloat(getComputedStyle(element).lineHeight);
        const overflowTolerance = Number.isFinite(computedLineHeight) ? computedLineHeight * 0.6 : 2;

        if (
          element.offsetHeight < element.scrollHeight - overflowTolerance ||
          element.offsetWidth < element.scrollWidth - overflowTolerance
        ) {
          this.truncated = true;
          this.truncatable = true;
          this.expanded = false;
        } else {
          this.truncated = false;
          this.truncatable = false;
          this.expanded = true;
        }
      },
      open(el, newLabel) {
        const truncateEl = el.closest('.truncate-container').querySelector('.truncate-text');
        this.expanded = true;
        this.label = newLabel;
        if (truncateEl.classList.contains('truncate-expanded')) {
          this.truncated = true;
          return;
        }

        const truncateInnerEl = truncateEl.querySelector('.truncate-inner');
        const truncateInnerRect = truncateInnerEl.getBoundingClientRect();
        truncateEl.style.setProperty('--truncate-height-expanded', `${truncateInnerRect.height}px`);

        void truncateEl.offsetHeight;
        truncateEl.classList.add('truncate-expanded');
        this.truncated = false;
      },
      close(el, newLabel, isQuickview = false, isImageComparison = false) {
        this.label = newLabel;
        const truncateEl = el.closest('.truncate-container').querySelector('.truncate-text');
        const isInViewport = () => {
          const rect = truncateEl.getBoundingClientRect();
          return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.xViewport.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.xViewport.innerWidth || document.documentElement.clientWidth)
          );
        };
        this.truncated = true;
        if (!isInViewport() && !isQuickview) {
          if (isImageComparison) {
            this.$nextTick(() => {
              truncateEl.closest('.x-block-header').scrollIntoView({ behavior: 'smooth', block: 'center', container: 'nearest' });
            });
          } else {
            const scrollPosition = truncateEl.getBoundingClientRect().top + window.scrollY - 500;
            window.scrollTo({
              top: scrollPosition,
              behavior: 'smooth'
            });
          }
          truncateEl.style.transition = 'none';
          setTimeout(() => {
            truncateEl.style.transition = '';
          }, 1000);
        }
        truncateEl.classList.remove('truncate-expanded');
        this.expanded = false;
      }
    }));
  });
}
